( function ( $ ) {
  function setSelectImage() {
    var selected_sku = $("#tdi-all-variants option:selected").attr('data-sku');
    if (selected_sku !== undefined) {
      $("button.product__add-to-cart-button").show();
      sku_image = 'https://www.bodyjewellery.co.uk/assets/products/' + selected_sku + '/thumb/' + selected_sku + '.main.jpg';
      $("#product-select-image").attr('src', sku_image).show();
    } else {
      $("button.product__add-to-cart-button").hide();
      $("#product-select-image").hide();
    }
  }
  $("#tdi-all-variants").change(function(){
    setSelectImage();
  });
  setSelectImage();
  $("#christmas").change(function(){
    if($(this). prop("checked") == true){
      $(".christmas").show();
    } else {
      $(".christmas").hide();
    }
  });
} ) ( jQuery );